import { createContext, ComponentChildren } from 'preact';
import { Carrier } from 'interfaces/Carrier.interface';
import Shipment from 'interfaces/PmParcel';
import { useContext } from 'preact/hooks';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useCarrierInformationDisplay } from './hooks';

interface CurrentCarrierContextState {
  isShowingSwitcher: boolean;
  isShowCurrentCarrier: boolean;
  isCurrentCarrierAsDestinationCarrier: boolean;
  isLoading: boolean;
  carrierInfo: Carrier;
  switchCarrier: () => void;
}

const CarrierInformationContext = createContext(
  {} as CurrentCarrierContextState,
);

export const CarrierInformationProvider = ({
  shipment,
  children,
}: {
  shipment: Shipment;
  children: ComponentChildren;
}) => {
  const { trackingDetailsBox } = usePTPConfigContext();
  const { shouldShowDestinationCarrier } = trackingDetailsBox;

  const {
    isShowingSwitcher,
    isShowCurrentCarrier,
    isCurrentCarrierAsDestinationCarrier,
    isLoading,
    carrierInfo,
    switchCarrier,
  } = useCarrierInformationDisplay(shipment, shouldShowDestinationCarrier);

  return (
    <CarrierInformationContext.Provider
      value={{
        isShowingSwitcher,
        isShowCurrentCarrier,
        isCurrentCarrierAsDestinationCarrier,
        isLoading,
        carrierInfo,
        switchCarrier,
      }}
    >
      {children}
    </CarrierInformationContext.Provider>
  );
};

export const useCarrierInformation = () => {
  const ctx = useContext(CarrierInformationContext);

  if (!ctx) {
    throw new Error(
      'useCarrierInformation must be used within a CarrierInformationContext',
    );
  }

  return ctx;
};
